module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-large-10x25-4a00370c1a830ad1a454e26367b273b8.png";